import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePostFn(ENDPOINTS.CANCEL_SUBSCRIPTION, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
